import { render } from "./RestApiDocs.vue?vue&type=template&id=41062ecb&scoped=true"
import script from "./RestApiDocs.vue?vue&type=script&lang=js"
export * from "./RestApiDocs.vue?vue&type=script&lang=js"

import "./RestApiDocs.vue?vue&type=style&index=0&id=41062ecb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41062ecb"]])

export default __exports__